import React from "react";
import { motion } from "framer-motion";
import { Instagram, Heart } from "lucide-react";
import { CONTACT } from "@/data/site";

const POSTS = [
  "https://images.unsplash.com/photo-1582560475093-ba66accbc424?crop=entropy&cs=srgb&fm=jpg&q=80&w=500",
  "https://images.unsplash.com/photo-1639772823849-6efbd173043c?crop=entropy&cs=srgb&fm=jpg&q=80&w=500",
  "https://images.unsplash.com/photo-1614935151651-0bea6508db6b?crop=entropy&cs=srgb&fm=jpg&q=80&w=500",
  "https://images.unsplash.com/photo-1582719471384-894fbb16e074?crop=entropy&cs=srgb&fm=jpg&q=80&w=500",
  "https://images.unsplash.com/photo-1606206591513-adbfbdd7a177?crop=entropy&cs=srgb&fm=jpg&q=80&w=500",
  "https://images.unsplash.com/photo-1579154204601-01588f351e67?crop=entropy&cs=srgb&fm=jpg&q=80&w=500",
];

export default function InstagramSection() {
  return (
    <section className="py-20 md:py-28 bg-slate-50/60" data-testid="instagram-section">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <div className="text-center max-w-2xl mx-auto">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-turq-dark">Follow Us</span>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-navy mt-3 tracking-tight">DOABA on Instagram</h2>
          <a href={CONTACT.instagram} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 text-turq-dark font-medium mt-3 hover:underline" data-testid="instagram-handle-link">
            <Instagram className="w-4 h-4" /> {CONTACT.instagramHandle}
          </a>
        </div>

        <div className="mt-10 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {POSTS.map((src, i) => (
            <motion.a key={i} href={CONTACT.instagram} target="_blank" rel="noreferrer"
              initial={{ opacity: 0, scale: 0.9 }} whileInView={{ opacity: 1, scale: 1 }} viewport={{ once: true }} transition={{ delay: i * 0.06 }}
              className="group relative aspect-square rounded-2xl overflow-hidden" data-testid={`instagram-post-${i}`}>
              <img src={src} alt="DOABA Instagram post" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" loading="lazy" />
              <div className="absolute inset-0 bg-navy/0 group-hover:bg-navy/40 transition-colors flex items-center justify-center">
                <Instagram className="w-7 h-7 text-white opacity-0 group-hover:opacity-100 transition-opacity" />
              </div>
            </motion.a>
          ))}
        </div>

        <div className="text-center mt-10">
          <a href={CONTACT.instagram} target="_blank" rel="noreferrer"
            className="inline-flex items-center gap-2 text-white rounded-full px-8 py-4 font-medium transition-all hover:-translate-y-0.5"
            style={{ background: "linear-gradient(45deg,#f09433,#e6683c,#dc2743,#cc2366,#bc1888)" }} data-testid="instagram-follow-btn">
            <Instagram className="w-5 h-5" /> Follow @doabadiagnosticslaboratory
          </a>
        </div>
      </div>
    </section>
  );
}
